// extracted by mini-css-extract-plugin
export default {"ListImages":"Partners_ListImages__0qtk6","LImage":"Partners_LImage__XrEdt"};